import { TextField } from "@mui/material";

export const ConfigName = ({ value, onChange, disabled = false, helperText }) => (
  <TextField
    id="witness-config-name-input"
    label="Nombre del formato de testigos"
    placeholder="Ejemplo: Casos judiciales"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    helperText={helperText}
    size="small"
    fullWidth
    inputProps={{ maxLength: 200 }}
  />
);